document.addEventListener('DOMContentLoaded', () => {

    const section = document.querySelector('.process-cards');

    if (!section) return;

    const cards = section.querySelectorAll('.process-card');

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            cards.forEach((card, index) => {

                setTimeout(() => {

                    card.classList.add('show');

                }, index * 220);

            });

            observer.unobserve(section);

        });

    }, {

        threshold: 0.25

    });

    observer.observe(section);

});